import React, { Component } from 'react';
import PropTypes from 'prop-types';

import '../styles/buttons-selectors.css';

class ButtonsSelector extends Component {
  state = {
    active: null,
  };

  componentDidMount() {
    const { selectedValue } = this.props;

    if (selectedValue) {
      this.setState({ active: selectedValue });
    }
  }

  handleButtonClick(value) {
    const { onClick } = this.props;
    this.setState({ active: value });

    if (onClick) {
      onClick(value);
    }
  }

  getButtonWidth(items) {
    return {
      width: `${100 / items.length}%`,
    };
  }

  renderButtons(items) {
    const { t } = this.context;
    const { active } = this.state;

    if (items && items.length > 0) {
      return items.map((item, index) => {
        return (
          <button
            className={`buttons-selector-container__btn ${active && active.value === item.value ? 'active-btn' : ''}`}
            onClick={() => this.handleButtonClick(item)}
            key={index}
            style={this.getButtonWidth(items)}
          >
            {t(item.label || item.text || '')}
          </button>
        );
      });
    } else return null;
  }

  render() {
    const { items } = this.props;

    return <div className="buttons-selector-container">{this.renderButtons(items)}</div>;
  }
}

ButtonsSelector.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default ButtonsSelector;



// WEBPACK FOOTER //
// ./src/app/shared/buttons-selector/components/buttons-selector.js